if (!customElements.get('image-grid-swiper')) {
  class ImageGridSwiper extends HTMLElement {
    constructor() {
      super();
        if (window.innerWidth <= 768) {
          new Swiper(this.querySelector('.swiper'), {
            slidesPerView: 'auto',
            spaceBetween: 16,
            freeMode: true,
            scrollbar: {
              el: this.querySelector('.swiper-scrollbar'),
              draggable: true,
              },
          });
        }
    }
  }
  customElements.define('image-grid-swiper', ImageGridSwiper);
}